import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { CallToAction } from 'components/atoms/callToAction';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';

const HomeCards = props => {
  const {
    description,
    description_mobile,
    heading,
    image_mobile,
    image_web,
    subHeading,
    tagWord,
  } = props;
  const handleClick = link => {
    RouteUtil.setRouteChange(props, `/homes`);
  };
  return (
    <>
      <img src={image_mobile} alt="image" className={'back-image'} />
      <HTMLView tagName={'h1'} className={'title'} html={heading} />
      <HTMLView
        tagName={'p'}
        className={'intro-description'}
        html={description_mobile}
      />
      <CallToAction
        text={'Explore Homes'}
        onClick={() => handleClick()}
        className={'explore-button'}
        mode={'light'}
      />
    </>
  );
};
export default withRouter(HomeCards);
